// docs/ux-operativa-v2-spec.md RF-2. `Esc` cierra el diálogo de más arriba
// haciendo click en su propia X: así el cierre es exactamente el mismo que
// con el mouse, sin que cada modal tenga que registrar nada.
//
// Los modales del sistema son de Vue (v-if + `.modal.show`), nunca pasan por
// el JS de Bootstrap, por eso su `Esc` nativo no actúa.
const DIALOG_SELECTOR = '.modal.show, .overlay-backdrop, [role="dialog"][aria-modal="true"]'
const CLOSE_SELECTOR = '[data-esc-cierra], .btn-close, [aria-label="Cerrar"], [aria-label="Close"]'

let installed = false
let isConfirmOpen = () => false

function isVisible(el) {
  return Boolean(el && el.isConnected && el.getClientRects().length)
}

function zIndexOf(el) {
  const value = Number.parseInt(window.getComputedStyle(el).zIndex, 10)
  return Number.isFinite(value) ? value : 0
}

// El de mayor z-index; a igual z-index, el último en el DOM.
function topmostDialog() {
  const dialogs = [...document.querySelectorAll(DIALOG_SELECTOR)].filter(isVisible)
  let top = null
  let topZ = -Infinity
  for (const dialog of dialogs) {
    const z = zIndexOf(dialog)
    if (z >= topZ) {
      top = dialog
      topZ = z
    }
  }
  return top
}

function closeControlOf(dialog) {
  return [...dialog.querySelectorAll(CLOSE_SELECTOR)].find(isVisible) || null
}

function handleKeydown(event) {
  if (event.key !== 'Escape' || event.repeat) return
  if (isConfirmOpen()) return

  const dialog = topmostDialog()
  if (!dialog) return

  // Se decide después de que corrieron los demás listeners: si alguno ya
  // atendió el Esc (CargaInicialStock, ProviderSelect, atajos de cobro…), o el
  // diálogo ya se cerró, no se cierra otro más.
  window.setTimeout(() => {
    if (event.defaultPrevented) return
    if (!isVisible(dialog) || !dialog.matches(DIALOG_SELECTOR)) return
    if (dialog.dataset.esc === 'off' || dialog.dataset.bsBackdrop === 'static') return
    const control = closeControlOf(dialog)
    if (!control || control.disabled) return
    control.click()
  }, 0)
}

export function install(options = {}) {
  if (typeof options.isConfirmOpen === 'function') isConfirmOpen = options.isConfirmOpen
  if (installed) return
  window.addEventListener('keydown', handleKeydown)
  installed = true
}

export function uninstall() {
  if (!installed) return
  window.removeEventListener('keydown', handleKeydown)
  installed = false
}

export default { install, uninstall }
